<template>
  <div class="box" >
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: "PageMain",
    data(){
      return{
      }
    },

    created() {
    },
    refresh(){

    }
  }
</script>

<style scoped lang="scss">
  .box {
    width: 100%;
    //padding: 15px;
    min-height: -webkit-calc(100vh - 250px);
    min-height: calc(100vh - 230px);
  }

</style>



// WEBPACK FOOTER //
// src/views/layout/components/PageMain.vue